<template>
  <page>
    <div>
      <div class="account-choice">
        <div class="account-tips">请选择一种账号作为会员账号</div>
        <div class="account-explain">（选定并购买会员后不可更改账号）</div>
        <div>
          <div
            class="account-list"
            @click="loginSwitch('phoneDynameic')"
            v-if="!getTencentAppCodeList.includes(appCode)"
          >
            <img src="@/assets/mobile.png" /><span>手机登录</span>
          </div>
          <template
            v-if="this.$getBrowser() !== 'alipay' && appCode !== '7885'"
          >
            <div
              class="account-list"
              @click="loginSwitch('weixin')"
              v-if="this.$getBrowser() !== 'other'"
            >
              <img src="@/assets/weixin.png" /><span>微信激活</span>
            </div>
            <div class="account-list" @click="loginSwitch('qq')">
              <img src="@/assets/qq.png" /><span>QQ 激活</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </page>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      appCode: this.$route.query.appCode
    }
  },
  computed: {
    ...mapGetters(['getTencentAppCodeList', 'getSetMealData'])
  },
  methods: {
    loginSwitch (type) {
      let buyType = this.$route.query.buyType
      // groupCode和actCode 都是拼团必须的参数
      let redirectUrl = window.location.origin +
        '/paying?number=1&goodsId=' +
        this.$route.query.goodsId +
        '&buyType=' +
        buyType +
        '&goodsType=1'
      if (this.$route.query.actCode) {
        redirectUrl += '&actCode=' + this.$route.query.actCode
      }
      if (this.$route.query.groupCode) {
        redirectUrl += '&groupCode=' + this.$route.query.groupCode
      }
      if (this.$route.query.preOrderSn) {
        redirectUrl += '&preOrderSn=' + this.$route.query.preOrderSn
      }

      let redirectTo = encodeURIComponent(redirectUrl)
      this.$signIn(type, redirectTo)
    }
  },
  mounted () {
    if (this.$getBrowser() === 'alipay') this.loginSwitch('phoneDynameic')
  }
}
</script>
<style lang="stylus" scoped>
.page
  background #efeff4
.account-choice
  text-align center
  padding-top 100px
.account-choice .account-tips
  font-size 18px
  line-height 30px
  height 30px
.account-choice .account-explain
  font-size 14px
  line-height 20px
  height 20px
  padding-bottom 20px
  color #666666
.account-choice .account-list
  height 54px
  width 305px
  line-height 54px
  background #ffffff
  margin 15px auto 0 auto
  border-radius 50px
.account-choice .account-list img
  height 25px
  vertical-align middle
.account-choice .account-list span
  font-size 18px
  color #808080
  padding-left 20px
</style>
